<div class="flex flex-col column-filter-dialog">
  <div class="flex flex-row mb-8 justify-between">
  <div class="flex flex-col">
    <label class="headline-2 cobHeader fw-700 fs-24">{{dynamicFormModel.property.title | titlecase}}</label>
    <label class="headline-2 cobHeader">{{instanceName}}</label>
  </div>
  <mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" (click)="sidenavService.closeRightSidenav()"></mat-icon>
</div>
<mat-divider class="w-100-percent divider-color"></mat-divider>
<div class="content">
<form *ngIf="templatesMap" [formGroup]="dynamicFormModel.formGroup" class="flex flex-col mat-headline-6 mt-32 dynamic-form" #ngForm="ngForm">
  <ng-container [ngTemplateOutlet]="templatesMap[dynamicFormModel.property.type]"
    [ngTemplateOutletContext]="{control: dynamicFormModel.formGroup.get(dynamicFormModel.property.name), property: dynamicFormModel.property, formGroup: dynamicFormModel.formGroup, showTitle: showTopLevelTitle}"></ng-container>
</form>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.BOOLEAN" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup" let-index="index">
<div class="flex flex-col form-field boolean-field" [ngClass]="{'left-column': (index % 3)}">
    <div *ngIf="showTitle" class="flex flex-row mb-4">
      <label>{{ property.title | uppercase }}</label>
      <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="property.description" class="info-icon"></mat-icon>
      <span *ngIf="property.required" class="mandatory mt--12 mat-body-2">*</span>
    </div>
    <mat-slide-toggle color="primary" [formControl]="setProperties(control, property.default, 'boolean', property)" [disabled]="property?.updatedValue"></mat-slide-toggle>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.STRING" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup" let-index="index">
  <div *ngIf="!property['x-hidden'] || property['x-hidden'] === 'false'" class="flex flex-col form-field left-column">
    <div *ngIf="showTitle" class="flex flex-row mb-4">
      <label>{{ property.title | uppercase }}</label>
      <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="property.description" class="info-icon"></mat-icon>
      <span *ngIf="property.required" class="mandatory mt--12 mat-body-2">*</span>
    </div>
    <input class="blend-border cob-values" *ngIf="property.default" [formControl]="setProperties(control, property.default)" [required]="property.mandatory" [readonly]="(property?.updatedValue && property['x-edit'] === 'static') || (property?.updatedValue && !property['x-edit'])">
    <input class="blend-border cob-values" *ngIf="!property.default" [placeholder]="!property.secretField ? (property.placeholder || 'CREATE_SERVICE.ENTER' | transloco: { propertyName: property.title}) : ' '" [formControl]="control" [required]="property.mandatory" [readonly]="(property?.updatedValue && property['x-edit'] === 'static') || (property?.updatedValue && !property['x-edit'])">
    <app-error [control]="control"></app-error>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.SELECT" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup" let-index="index">
  <div class="form-field" [ngClass]="{'left-column': (index % 3)}">
    <div *ngIf="showTitle" class="flex flex-row mb-4">
      <label>{{ property.title | uppercase }}</label>
      <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="property.description" class="info-icon"></mat-icon>
      <span *ngIf="property.required" class="mandatory mt--12 mat-body-2">*</span>
    </div>
    <select class="blend-border" [formControl]="setProperties(control, property.default)" [ngClass]="{ 'placeholder': control.value === null, 'readonly': property?.updatedValue }">
      <option [ngValue]="null" *ngIf="!property.default" [disabled]="true" hidden>{{ property.placeholder || 'CREATE_SERVICE.SELECT' | transloco: { propertyName: property.title } }}</option>
      <option *ngFor="let value of property.enum" [value]="value">{{ value }}</option>
    </select>
    <app-error [control]="control"></app-error>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.DATE" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup" let-index="index">
  <div *ngIf="(property.customName !== 'schedule1' && property.customName !== 'schedule2')" class="form-field" [formGroup]="formGroup" [ngClass]="{'left-column': (index % 3)}">
    <div class="flex flex-row mb-4" *ngIf="showTitle">
      <label>{{ property.title | uppercase }}</label>
      <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="property.description" class="info-icon"></mat-icon>
      <span *ngIf="property.required" class="mandatory mt--12 mat-body-2">*</span>
    </div>
    <app-datepicker [control]="setProperties(control, property.default)" [placeholder]="property.placeholder || 'CREATE_SERVICE.SELECT' | transloco: { propertyName: property.title }" [ngClass]="{'readonly': property?.updatedValue}"></app-datepicker>
    <app-error [control]="control"></app-error>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.INTEGER" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup" let-index="index">
  <div class="flex flex-col form-field" [ngClass]="{'left-column': (index % 3)}">
    <div class="flex flex-row mb-4" *ngIf="showTitle">
      <label>{{ property.title | uppercase }}</label>
      <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="property.description" class="info-icon"></mat-icon>
      <span *ngIf="property.required" class="mandatory mr-- mat-body-2">*</span>
    </div>
    <input class="blend-border" *ngIf="property.default" [formControl]="setProperties(control, property.default)" [required]="property.mandatory" appNumeric allowNegative="true" [readonly]="property?.updatedValue">
    <input type="text" class="blend-border" *ngIf="!property.default" [placeholder]="property.placeholder || 'CREATE_SERVICE.ENTER' | transloco: { propertyName: property.title }" [formControl]="control" [required]="property.mandatory" appNumeric allowNegative="true" [readonly]="property?.updatedValue">
    <app-error [control]="control"></app-error>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.NUMBER" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup" let-index="index">
  <div class="flex flex-col form-field" [ngClass]="{'left-column': (index % 3)}">
    <div *ngIf="showTitle" class="flex flex-row mb-4">
      <label>{{ property.title | uppercase }}</label>
      <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="property.description" class="info-icon"></mat-icon>
      <span *ngIf="property.required" class="mandatory mt--12 mat-body-2">*</span>
    </div>
    <input class="blend-border cob-values" *ngIf="property.default" [formControl]="setProperties(control, property.default)" [required]="property.mandatory" appNumeric allowNegative="true" [decimals]="16" [readonly]="property?.updatedValue">
    <input type="text" class="blend-border cob-values" *ngIf="!property.default" [placeholder]="property.placeholder || 'CREATE_SERVICE.ENTER' | transloco: { propertyName: property.title }" [formControl]="control" [required]="property.mandatory" appNumeric allowNegative="true" [decimals]="16" [readonly]="property?.updatedValue">
    <app-error [control]="control"></app-error>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.OBJECT" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup">
  <div [formGroup]="formGroup.get(property.name)" [ngClass]="{'left-column': (index % 3)}">

    <ng-container *ngFor="let nestedproperty of property.properties; let i = index" [ngTemplateOutlet]="templatesMap[nestedproperty.type]"
      [ngTemplateOutletContext]="{
        control: formGroup.get(property.name).get(nestedproperty.name),
        property: nestedproperty,
        formGroup: formGroup.get(property.name),
        showTitle: true,
        index: i + 1
      }"></ng-container>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.ARRAY" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup" let-index="index">
  <div class="flex flex-col form-field" [ngClass]="{'left-column': (index % 3)}">
    <div class="flex flex-row mb-4" *ngIf="showTitle">
      <label>{{ property.title | uppercase }}</label>
      <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="property.description" class="info-icon"></mat-icon>
      <span *ngIf="property.required" class="mandatory mt--12 mat-body-2">*</span>
    </div>

    <ng-container *ngIf="property.items?.enum; else freeTypeArray">
      <!-- <mat-select #matSelect [placeholder]="property.placeholder || 'CREATE_SERVICE.SELECT' | transloco: { propertyName: property.title }" [formControl]="setProperties(control, property.default)" [ngClass]="{ 'placeholder': control.value === null, 'readonly': disableMultiselectField(property) }" multiple>
        <mat-option *ngFor="let tag of property.items.enum" [value]="tag" [disabled]="selectedValues(tag, property)">{{tag}}</mat-option>
      </mat-select> -->
      <mat-select class="drop-down pt-0" #matSelect [placeholder]="property.placeholder || 'CREATE_SERVICE.SELECT' | transloco: { propertyName: property.title }" [formControl]="setMultiSelectProperties(control, property.default)" [ngClass]="{ 'placeholder': control.value === null}" multiple>
        <mat-option [ngClass]="{'select-option': disableMultiselectField(property) }"*ngFor="let tag of property.items.enum" [value]="tag" [disabled]="selectedValues(tag, property)">{{tag}}</mat-option>
      </mat-select>
    </ng-container>

    <ng-template #freeTypeArray>
      <mat-form-field appearance="outline">
        <mat-chip-list #chipList>
          <mat-chip *ngFor="let tag of control.value; let i = index;"
                    [removable]="true"
                    (removed)="removeTag(i, control)"
                    class="tags word-break-word fw-400">
            <div class="tag-content">{{tag}}</div>
            <mat-icon svgIcon="close" class="cursor-pointer cross-icon" matChipRemove></mat-icon>
          </mat-chip>
          <input *ngIf="property.items.type === propertyType.STRING" [required]="property.mandatory"
          [matChipInputFor]="chipList"
          [matChipInputAddOnBlur]="true"
          (matChipInputTokenEnd)="addTag($event, control)"
          class="hidden-input"
          autocomplete="off">
        </mat-chip-list>
      </mat-form-field>
    </ng-template>
    <app-error [control]="control"></app-error>
  </div>
</ng-template>

<ng-template [appNamedTemplate]="InstallationSchemaPropertyType.DATE" let-showTitle="showTitle" let-control="control" let-property="property" let-formGroup="formGroup" let-index="index">
  <mat-tab *ngIf="scheduleOne && property.customName === 'schedule1'" [ngClass]="{'left-column': (index % 3), 'disabled': (cobStatus === CobStatus.RECONFIGURE)}">
    <div class="test-results">
      <div class="flex flex-row tabs">
        <div class="test-tabs fs-20 mr-32 mb-12 cursor-pointer inactive"  [ngClass]="{'active fw-500': scheduleOne}" (click)="cobTabs('schedule1')">{{'TEST_RESULTS.SCHEDULE1' | transloco}}</div>
        <div class="test-tabs fs-20 mb-12 cursor-pointer inactive" [ngClass]="{'active fw-500': scheduleTwo}" (click)="cobTabs('schedule2')">{{'TEST_RESULTS.SCHEDULE2' | transloco}}</div>
      </div>
      <ng-container>
        <div *ngIf="property.customName === 'schedule1'" class="fs-10" [formGroup]="formGroup">
          <div class="flex flex-row mb-4" *ngIf="showTitle">
            <label>{{ property.title | uppercase }}</label>
            <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="property.description" class="info-icon mt-4"></mat-icon>
            <span *ngIf="property.required" class="mandatory mt--12 mat-body-2">*</span>
          </div>
          <div class="flex flex-row">
            <div *ngFor="let item of daysSch1" class="mr-12">
                <div class="flex flex-row w-100-percent mb-16" (click)="selectDays(item)">
                    <mat-icon [svgIcon]="item?.checked ? 'check_box' : 'check_box_outline_blank'" class="icon-md-1 mr-4 cursor-pointer"></mat-icon>
                    <span class="fw-400 fs-16">{{item.name}}</span>
                </div>
            </div>
        </div>
        <div class="flex flex-row">
          <div class="flex flex-col mr-24"> 
              <div class="flex flex-row flex-wrap mb-4">
                  <label class="schedule-spacing fw-700 fs-12">{{'TEST_RESULTS.HH' | transloco | uppercase}}</label>
              </div>
              <form>
                  <input [formControl]="hoursMinutesSch1.get('hours')" value="0" type="number" id="hours" onKeyDown="return false" name="hours" min="0" max="23">
              </form>
          </div>
          <div class="flex flex-col">
              <div class="flex flex-row flex-wrap mb-4">
                  <label class="schedule-spacing fw-700 fs-12">{{'TEST_RESULTS.MM' | transloco | uppercase}}</label>
              </div>
              <form>
                  <input [formControl]="hoursMinutesSch1.get('minutes')" value="0" type="number" id="minutes" onKeyDown="return false" name="minutes" min="0" max="59">
              </form>
          </div>
      </div>
      <div class="error" *ngIf="bothSameValue || requiredError || atleastOneDay">{{requiredError ? ('TEST_RESULTS.required' | transloco) :(atleastOneDay ? ('TEST_RESULTS.daysNeededSch1' | transloco) : ('TEST_RESULTS.scheduleDiff' | transloco))}}</div>
        </div>
      </ng-container>
      </div>
      </mat-tab>
      <mat-tab *ngIf="scheduleTwo && property.customName === 'schedule2'" [ngClass]="{'disabled': reconfigure}">
        <div class="test-results">
          <div class="flex flex-row tabs">
            <div class="test-tabs fs-20 mr-32 mb-12 cursor-pointer inactive"  [ngClass]="{'active fw-500': scheduleOne}" (click)="cobTabs('schedule1')">{{'TEST_RESULTS.SCHEDULE1' | transloco}}</div>
            <div class="test-tabs fs-20 mb-12 cursor-pointer inactive" [ngClass]="{'active fw-500': scheduleTwo}" (click)="cobTabs('schedule2')">{{'TEST_RESULTS.SCHEDULE2' | transloco}}</div>
          </div>
      <ng-container>
        <div *ngIf="property.customName === 'schedule2'" class="fs-10" [formGroup]="formGroup">
          <div class="flex flex-row mb-4" *ngIf="showTitle">
            <label>{{ property.title | uppercase }}</label>
            <mat-icon *ngIf="property.description" svgIcon="info" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="property.description" class="info-icon mt-4"></mat-icon>
            <span *ngIf="property.required" class="mandatory mt--12 mat-body-2">*</span>
          </div>
          <div class="flex flex-row">
            <div *ngFor="let item of daysSch2" class="mr-12">
                <div class="flex flex-row w-100-percent mb-16" (click)="selectDays(item)">
                    <mat-icon [svgIcon]="item?.checked ? 'check_box' : 'check_box_outline_blank'" class="icon-md-1 mr-4 cursor-pointer"></mat-icon>
                    <span class="fw-400 fs-16">{{item.name}}</span>
                </div>
            </div>
        </div>
        <div class="flex flex-row">
          <div class="flex flex-col mr-24"> 
              <div class="flex flex-row flex-wrap mb-4">
                  <label class="schedule-spacing fw-700 fs-12">{{'TEST_RESULTS.HH' | transloco | uppercase}}</label>
              </div>
              <form>
                  <input [formControl]="hoursMinutesSch2.get('hours')" value="0" type="number" id="hours" onKeyDown="return false" name="hours" min="0" max="23">
              </form>
          </div>
          <div class="flex flex-col">
              <div class="flex flex-row flex-wrap mb-4">
                  <label class="schedule-spacing fw-700 fs-12">{{'TEST_RESULTS.MM' | transloco | uppercase}}</label>
              </div>
              <form>
                  <input [formControl]="hoursMinutesSch2.get('minutes')" value="0" type="number" id="minutes" onKeyDown="return false" name="minutes" min="0" max="59">
              </form>
          </div>
      </div>
      <div class="error" *ngIf="bothSameValue">{{'TEST_RESULTS.scheduleDiff' | transloco}}</div>
      </div>
      </ng-container>
      </div>
    </mat-tab>
</ng-template>
</div>
<mat-divider class="w-100-percent mb-32 divider-color"></mat-divider>
<div class="flex flex-col gap-x-4 mb-10">
  <div class="flex flex-row justify-end gap-x-6">
    <button class="white" (click)="sidenavService.closeRightSidenav()">{{'DIALOG.CANCEL'| transloco}}</button>
    <button type="submit" class="accent" (click)="closeSidenav(dynamicFormModel)">{{'TENANT_FORM.SUBMIT' | transloco}}</button>
  </div>
</div>
</div>


